// app 1.4.70 (Alexander, 21 Oct) — the take page's "fixed position" rule for any field: nothing moves vertically.
// The same two parts as noteTakeView's name field (1.4.65–1.4.66):
//  1. holdStill — a tap on the field is taken over: no default (the browser would scroll the field into view) and
//     the field focused without scrolling, still inside the tap so the keyboard opens. A tap on a field that
//     already has the caret is the phone's own (it places the caret).
//  2. keepLine — the fallback for a phone that scrolls anyway: once the keyboard has opened (the visual viewport
//     shrinks), the line above the field is brought back just above it, if that keeps the field above the keys.

export function holdStill(el: HTMLInputElement | null): void {
  el?.addEventListener("touchend", (e) => {
    if (document.activeElement === el || el.readOnly || el.disabled) return;
    e.preventDefault();
    el.focus({ preventScroll: true });
    try { const n = el.value.length; el.setSelectionRange(n, n); } catch { /* not every input type */ }
  }, { passive: false });
}

/** holdStill, plus the keepLine fallback for `line` (the words above the field). */
export function holdField(el: HTMLInputElement | null, line: () => HTMLElement | null): void {
  if (!el) return;
  holdStill(el);
  const keepLine = () => {
    if (document.activeElement !== el) return;
    const ex = line();
    const vv = window.visualViewport;
    if (!ex || !vv) return;
    const top = ex.getBoundingClientRect().top - vv.offsetTop; // where the line sits in what's visible
    const fieldBottom = el.getBoundingClientRect().bottom - vv.offsetTop;
    const lift = 12 - top; // > 0: the line is above the visible top by this much (plus a margin)
    if (lift <= 0 || fieldBottom + lift > vv.height - 8) return; // in view already, or bringing it back would hide the field
    window.scrollBy({ top: -lift, behavior: "smooth" });
  };
  el.addEventListener("focus", () => {
    const vv = window.visualViewport;
    let done = false;
    const once = () => { if (done) return; done = true; vv?.removeEventListener("resize", once); window.setTimeout(keepLine, 60); };
    vv?.addEventListener("resize", once);
    window.setTimeout(() => { vv?.removeEventListener("resize", once); keepLine(); }, 650); // a keyboard already up: no resize
  });
}
